import { MarkerType } from "reactflow";

// 间距
export const distance = 10;
export const selectApiReg = /^\//;
export const forbidAddToPreviewType = ["uploadFile", "Agent"];

export const markerEnd = {
  type: MarkerType.ArrowClosed,
  width: 12,
  height: 8,
  color: "#B0B0B7",
};

export const transparentMarkerEnd = {
  type: MarkerType.ArrowClosed,
  width: 12,
  height: 12,
  color: "transparent",
};

export const selectedMarkerEnd = {
  type: MarkerType.ArrowClosed,
  width: 12,
  height: 12,
  color: "#e84e4e",
};

export const nodeDataRefTpl = {
  nodeIndexRef: { current: 0 },
  edgeIndexRef: { current: 0 },
  isResized: false,
  loadingNodeHtml: false,
  share: false,
  showWarning: false,
  showStopGenerateBtn: false,
  showFeedback: false,
  fromList: false,
  placeholder: "",
  textAreaValue: "",
  inputTitle: undefined,
  generatedLabel: undefined,
  displayType: "text",
  originId: "",
  parentNode: "",
  parentNodeId: "",
  errorText: "",
  childNode: [],
  chatBoxParam: [],
  dropUploadFileData: {},
  abortNode: {},
};

export const edgeDataRefTpl = {
  nodes: { current: [] },
  nodeIndexRef: { current: 0 },
  isGetQuery: false,
  getQueryLoading: false,
  isCreatedBySlice: false,
  isSliceAutoRun: false,
  isApiFunction: false,
  isUndoRedoAdd: false,
  isNewEdgeRunRef: { current: false },
  originSource: "",
  originTarget: "",
  sourceHandle: "b",
  targetHandle: "a",
  selectedApi: {},
  lineParam: {
    loading: false,
    queryValue: "",
    enterText: "",
    lineType: "prompt",
    createFromCot: false,
    // 用来禁用边上的 run 按钮
    disabledRun: false,
  },
};
export const bottomVariants = {
  init: {
    opacity: 0,
    scale: 0,
  },
  show: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.5,
      type: "spring",
      ease: "easeInOut",
    },
  },
  hide: {
    opacity: 0,
    scale: 0,
    transition: {
      duration: 0.5,
      type: "spring",
      ease: "easeOut",
    },
  },
};
